export const USER_TYPE = "usr_type";
export const USER_PRIVILEGE = "ckob_privileges";
export const USER_GROUP_PRIVILEGE = "ckob_privileges_group";
export const USER_MAIN_ROLE = "ckob_main_role";
export const USER_MAIN_ROLE_I = "ckob_role_i";

export const dictionaryEntryTypeMap = {
  periodic_check: 3,
  tech_expertise: 4,
  fire_maintenance: 5,
  building_work: 6,
  building_disaster: 7,
  admin_decision: 8
};

export function getDictionaryName(typeName) {
  const nr = dictionaryEntryTypeMap[typeName] || "";
  return `ckob_document_type_t${nr}`;
}
